module.exports = "https://health.dajiuxing.com.cn/img/views/binding/img/step_04.jpg"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2Fbinding%2Fimg%2Fstep_04.jpg
// module id = Pg/M
// module chunks = 93